import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { getAllCandidates, GET_CANDIDATES, resendCandidateInvitation } from 'app/redux/actions/Candidate/candidate.actions';
import { notificationError, notificationSuccess } from 'app/redux/actions/Notification/notifications.actions';
import { COPY_CANDIDATE_LINK, COPY_CANDIDATE_LINK_ERROR } from 'app/Snackbar/NotificationMessages';
import { selectAllCandidates } from 'app/redux/selectors/Candidate/candidate.selector';
import { enumStatus } from 'app/utils/CandidateStatusEnum';
import { optionsTooltip } from 'app/utils/OptionsTooltipEnum';
import MaterialTable from 'material-table';
import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createLoadingSelector } from '../../redux/selectors/APISelector/APISelector';
import CandidateResult from '../CandidateResult/CandidateResult';
import './CandidateTable.scss';


// Doit rester aligné sur CANDIDAT_WELCOME_PAGE_URL dans app/Routes.
const CANDIDATE_WELCOME_PATH = '/candidat';

export function CandidateTable(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllCandidates());
    }, []);

    const allCandidates = useSelector(selectAllCandidates);

    const isFetchingCandidates = useSelector(createLoadingSelector([GET_CANDIDATES]));

    const [showResultCandidate, setShowResultCandidate] = useState(Boolean(props.candidate));
    const [actualCandidate, setActualCandidate] = useState(props.candidate);

    const translateEnum = (status) => Object.entries(enumStatus).find(([key]) => {
        if(key === status) {
            return true;
        }
        return false;
    })[1];

    const onCloseDialog = () => {
        setShowResultCandidate(false);
        setActualCandidate(null);
    };

    const onResendInvitation = (candidate) => {
        dispatch(resendCandidateInvitation(candidate.uuid));
    };

    const onCopyLink = async(candidate) => {
        const link = `${window.location.origin}${CANDIDATE_WELCOME_PATH}/${candidate.uuid}`;
        try {
            await navigator.clipboard.writeText(link);
            dispatch(notificationSuccess(COPY_CANDIDATE_LINK));
        } catch {
            dispatch(notificationError(COPY_CANDIDATE_LINK_ERROR));
        }
    };

    const columns = [
        {
            title: 'Nom',
            field: 'name',
            render: (rowData) => <Fragment key={rowData.id}>
                {`${rowData.firstName} ${rowData.lastName}`}
            </Fragment>,
            cellStyle: {
                width: '25%',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                wordSpacing: 'normal'
            },
            customFilterAndSearch: (term, rowData) => (`${rowData.firstName} ${rowData.lastName}`).toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) !== -1,
            headerStyle: {
                width: '25%'
            },
            sorting: false
        },
        {
            title: 'Email',
            field: 'email',
            render: (rowData) => <>
                <Fragment key={rowData.id}>
                    {rowData.email}
                </Fragment>
            </>,
            cellStyle: {
                width: '30%',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                wordSpacing: 'normal'
            },
            headerStyle: {
                width: '30%'
            },
            sorting: false
        },
        {
            title: 'Invitation envoyée le',
            field: 'creationDate',

            render: (rowData) => <>
                <Fragment key={rowData.id}>
                    <Tooltip
                        title={new Intl.DateTimeFormat('fr-FR', optionsTooltip).format(new Date(rowData.creationDate))}
                        placement="left-start"
                        className="displayStatData">
                        <div><i>{new Intl.DateTimeFormat('fr-FR').format(new Date(rowData.creationDate))}</i> </div>
                    </Tooltip>
                </Fragment>
            </>,
            cellStyle: {
                width: '20%',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                wordSpacing: 'normal'
            },
            headerStyle: {
                width: '20%'
            }
        },
        {
            title: 'Statut',
            field: 'status',

            render: (rowData) => <Fragment key={rowData.id} >
                <div className={ translateEnum(rowData.status) === enumStatus.ERROR ? 'error-status' : '' }>
                    { translateEnum(rowData.status) }
                    {
                        (
                            rowData.status === 'DONE' ||
                            rowData.status === 'REJECTED' ||
                            rowData.status === 'NEXT_STEP'
                        ) &&
                        <IconButton
                            onClick={() => {
                                setShowResultCandidate(true);
                                setActualCandidate(rowData);
                            }}
                        >
                            <VisibilityOutlinedIcon/>
                        </IconButton>
                    }
                    {
                        rowData.status === 'INACTIVE' &&
                        <>
                            <Tooltip title="Relancer" placement="top">
                                <IconButton
                                    aria-label="Relancer"
                                    onClick={() => onResendInvitation(rowData)}
                                >
                                    <SendOutlinedIcon/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Récupérer le lien" placement="top">
                                <IconButton
                                    aria-label="Récupérer le lien"
                                    onClick={() => onCopyLink(rowData)}
                                >
                                    <LinkOutlinedIcon/>
                                </IconButton>
                            </Tooltip>
                        </>
                    }
                </div>
            </Fragment>,
            cellStyle: {
                width: '15%',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                wordSpacing: 'normal'
            },
            customFilterAndSearch: (term, rowData) => (translateEnum(rowData.status).toLocaleLowerCase()
                .indexOf(term.toLocaleLowerCase()) !== -1),
            headerStyle: {
                width: '15%'
            }
        }
    ];

    return (
        <section>
            <div>
                <MaterialTable className="Table"
                    columns={columns}
                    data={allCandidates.sort((elem1, elem2) => (elem1.creationDate < elem2.creationDate) ? 1 : -1)}
                    title="Liste des Candidats"
                    isLoading={isFetchingCandidates && !allCandidates}
                    localization={{
                        'header': {
                            'actions': ''
                        },
                        'body': {
                            'emptyDataSourceMessage': (isFetchingCandidates && !allCandidates)
                                ? 'En attente de chargement...'
                                : 'Aucun candidat trouvé'
                        },
                        'pagination': {
                            'labelDisplayedRows': '{from}-{to} / {count}',
                            'labelRowsSelect': '',
                            'nextTooltip': 'Page suivante',
                            'previousTooltip': 'Page précédente',
                            'firstTooltip': 'Première page',
                            'lastTooltip': 'Dernière page'
                        },
                        'toolbar': {
                            'searchPlaceholder': 'Rechercher',
                            'searchTooltip': 'Rechercher'
                        }
                    }}
                />
                {showResultCandidate &&
                    <CandidateResult
                        open={showResultCandidate}
                        onClose={onCloseDialog}
                        candidate={actualCandidate}
                    />
                }
            </div>
        </section>
    );
}

CandidateTable.propTypes = {
    candidate: PropTypes.object
};
